/**
 * Shared helpers for optional currency fields (2 decimal places for display).
 */
/** Upper cap for delivery fee / min-order admin inputs (supports IDR/VND-scale amounts). */
export const MAX_DELIVERY_MONEY_AMOUNT = 9999999;
export function formatMoneyInputDisplay(value) {
    if (value === '' || value === undefined || value === null)
        return '';
    const n = Number(value);
    if (Number.isNaN(n))
        return '';
    return n.toFixed(2);
}
export function parseMoneyInputChange(raw) {
    if (raw.trim() === '')
        return '';
    const n = parseFloat(raw);
    return Number.isNaN(n) ? 0 : n;
}
export function roundMoneyTwoDecimals(n) {
    return parseFloat(n.toFixed(2));
}
export function clampMoneyAmount(n, max = MAX_DELIVERY_MONEY_AMOUNT) {
    if (n < 0)
        return 0;
    if (n > max)
        return max;
    return n;
}
export function isValidMoneyInput(raw, max = MAX_DELIVERY_MONEY_AMOUNT) {
    if (!/^\d*(\.\d{0,2})?$/.test(raw))
        return false;
    if (raw === '' || raw === '.' || raw.endsWith('.'))
        return true;
    const n = parseFloat(raw);
    return !Number.isNaN(n) && n <= max;
}
//# sourceMappingURL=money-input-helpers.js.map